// module to import project content data

const data = {
  watiamlost: {
    projectName: 'WatIAMLost (Project Program Winner)',
    iconsUsed: ['nodejs', 'mongodb', 'reactnative', 'expressjs'],
  },
  age: {
    projectName: 'AGE (CS246E Final Project)',
    iconsUsed: ['cpp'],
  },
  blow_it_up: {
    projectName: 'BlowItUp (HTN 2021 Winner)',
    iconsUsed: ['html', 'css', 'js'],
    projectLink: 'http://blowitup.duckdns.org/',
  },
  my_course_graph: {
    projectName: 'My Course Graph',
    iconsUsed: ['expressjs', 'react', 'nodejs'],
    projectLink: 'https://course-graph.herokuapp.com/',
  },
  wclasses: {
    projectName: 'WClasses Website',
    iconsUsed: ['mongodb', 'beautifulsoup', 'react', 'nextjs'],
    projectLink: 'https://wclasses.vercel.app/',
  },
  pmc_website: {
    projectName: 'Pure Math Club Website',
    iconsUsed: ['react', 'sass', 'nodejs'],
    projectLink: 'https://puremath.club',
  },
  linear_collatz: {
    projectName: 'Linear Collatz',
    iconsUsed: ['react', 'reactbootstrap', 'nodejs'],
    projectLink: 'https://linear-collatz.herokuapp.com/',
  },
  cs241_syntax_highlighting: {
    projectName: 'CS241 Syntax Highlighting',
    iconsUsed: ['vscode'],
    projectLink: 'https://github.com/mcpenguin/cs241-syntax-highlighting',
  },
  malaysia_covid: {
    projectName: 'Malaysia COVID-19 Data',
    iconsUsed: ['mysql', 'beautifulsoup', 'jupyter', 'python'],
    projectLink: 'https://github.com/mcpenguin/malaysia-covid',
  },
  // joget_fb_marketplace: {
  //   projectName: 'Joget FB Marketplace',
  //   iconsUsed: ['joget', 'java', 'mysql', 'js'],
  // },
  // skyblock_calculator: {
  //   projectName: 'Skyblock Calculator',
  //   iconsUsed: ['java', 'excel'],
  //   projectLink: 'https://github.com/mcpenguin/hypixel-skyblock-calc',
  // },
  // "student_reg_gui": {
  //     projectName: "Student Attendance GUI",
  //     iconsUsed: ['java'],
  //     projectLink: "https://github.com/mcpenguin/student-reg-gui",
  // },
  // "compass_initiative": {
  //     projectName: "Compass Website",
  //     iconsUsed: ['wordpress', 'bluehost'],
  // },
  // "calculator": {
  //     projectName: "Tkinter Calculator",
  //     projectLink: "https://github.com/mcpenguin/calculator",
  //     iconsUsed:['tkinter', 'python'],
  // },
};

export default data;
